import { BrandLogo } from '../components/brand-logo.jsx';
import { BrandingLegalLinks } from '../components/branding.jsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/card.jsx';

/**
 * Centered card layout for login / password pages (logo and Impressum/Datenschutz links from the runtime branding).
 * @param {{ appName: string, title: string, description?: import('react').ReactNode, children: import('react').ReactNode, footer?: import('react').ReactNode }} props
 */
export function AuthLayout({ appName, title, description, children, footer }) {
  return (
    <main data-slot="auth-layout" className="flex min-h-dvh flex-col items-center justify-center bg-muted/40 px-4 py-10">
      <div className="mb-6 flex flex-col items-center gap-2 text-foreground">
        <BrandLogo className="h-20" />
        <span className="text-sm font-medium tracking-tight text-muted-foreground">{appName}</span>
      </div>
      <Card className="w-full max-w-sm gap-5 py-6">
        <CardHeader className="px-6">
          <CardTitle as="h1" className="text-h2">
            {title}
          </CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent className="px-6">{children}</CardContent>
      </Card>
      {footer && <div className="mt-4 text-center text-sm text-muted-foreground">{footer}</div>}
      <BrandingLegalLinks className="mt-6" />
    </main>
  );
}
